import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Ban, Unlock } from "lucide-react";
import { api, errMsg, fmtAZN } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const UsersAdmin = () => {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [target, setTarget] = useState(null);
  const [reason, setReason] = useState("");

  const load = useCallback(async () => { const { data } = await api.get("/admin/users"); setUsers(data); }, []);
  useEffect(() => { load(); }, [load]);

  const block = async () => {
    try {
      await api.post(`/admin/users/${target.id}/block`, { reason });
      toast.success("İstifadəçi bloklandı");
      setTarget(null); setReason(""); load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const unblock = async (u) => { await api.post(`/admin/users/${u.id}/unblock`); toast.success("Blok açıldı"); load(); };

  const list = users.filter((u) => u.email.includes(q.toLowerCase()));
  return (
    <div>
      <input className="jp-input mb-4 max-w-sm" placeholder="Email ilə axtar..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-user-search" />
      <div className="rounded-2xl border border-white/10 bg-[#111] divide-y divide-white/5" data-testid="admin-users-list">
        {list.map((u) => (
          <div key={u.id} className="flex flex-wrap items-center gap-3 px-5 py-3 text-sm" data-testid={`admin-user-${u.id}`}>
            <div className="flex-1 min-w-[200px]">
              <p>{u.email} {u.role === "admin" && <span className="ml-2 text-xs text-[#D4AF37]">admin</span>}</p>
              {u.blocked && <p className="text-xs text-red-400">Bloklanıb: {u.block_reason}</p>}
            </div>
            <span className="text-xs text-zinc-500">Dövriyyə: {fmtAZN(u.wagered)} / {fmtAZN(u.wager_required)}</span>
            <span className="font-display w-28 text-right">{fmtAZN(u.balance)}</span>
            {u.role !== "admin" && (u.blocked ? (
              <button onClick={() => unblock(u)} className="rounded-full px-3 py-1.5 text-xs flex items-center gap-1 bg-emerald-500/15 text-emerald-400" data-testid={`unblock-${u.id}`}><Unlock size={14} /> Bloku aç</button>
            ) : (
              <button onClick={() => setTarget(u)} className="rounded-full px-3 py-1.5 text-xs flex items-center gap-1 bg-red-500/15 text-red-400" data-testid={`block-${u.id}`}><Ban size={14} /> Blokla</button>
            ))}
          </div>
        ))}
      </div>
      <Dialog open={!!target} onOpenChange={(o) => !o && setTarget(null)}>
        <DialogContent className="bg-[#111] border-[#D4AF37]/40 text-white" data-testid="block-dialog">
          <DialogHeader><DialogTitle className="font-display">{target?.email} — blokla</DialogTitle></DialogHeader>
          <textarea className="jp-input min-h-[100px]" placeholder="Bloklama səbəbi" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="block-reason-input" />
          <button disabled={reason.trim().length < 2} onClick={block} className="btn-gold rounded-full py-3 font-display font-bold" data-testid="block-confirm-btn">Blokla</button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
